var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-skeleton"},_vm._l((_vm.countRows),function(k){return _c('van-row',{key:k,staticClass:"vue-skeleton-item"},[_c('van-col',{staticClass:"vue-skeleton-content",attrs:{"span":"24"}},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"title"}),_c('div',{staticClass:"title"})])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }